(function () {
  var root = document.querySelector('[data-spq]');
  if (!root || root.__spq) return;
  root.__spq = 1;
  var D;
  try { D = JSON.parse(root.querySelector('[data-spq-data]').textContent); } catch (e) { return; }
  var P = D.products || {};
  var REVISION = '2026-07-15';
  var STORE = 'spq_v1';
  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var ICON = {};
  var it = $('[data-spq-icons]');
  if (it) $$('[data-i]', it.content).forEach(function (n) { ICON[n.getAttribute('data-i')] = n.innerHTML; });
  function icon(n) { return ICON[n] || ''; }
  var artN = 0;
  function art(h) {
    var t = root.querySelector('template[data-spq-art="' + h + '"]');
    if (!t) return '';
    var n = ++artN;
    return t.innerHTML.replace(/id="([^"]+)"/g, 'id="$1_' + n + '"').replace(/url\(#([^)]+)\)/g, 'url(#$1_' + n + ')').replace(/href="#([^"]+)"/g, 'href="#$1_' + n + '"');
  }
  var nf;
  try { nf = new Intl.NumberFormat(D.locale || 'en', { style: 'currency', currency: D.cur || 'USD' }); } catch (e) { nf = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' }); }
  function fmt(c) { var s = nf.format((c || 0) / 100); if (Math.round(c) % 100 === 0) s = s.replace(/[.,]00(?=[^0-9]*$)/, ''); return s; }

  /* ---------- content ---------- */
  var GOALS = [
    { id: 'sleep', label: 'Sleep', word: 'sleep', sub: 'Wind down, rest well', icon: 'moon', k: 'sleep', h: 'sleep-rest-strips' },
    { id: 'energy', label: 'Energy', word: 'energy', sub: 'Steady, all-day drive', icon: 'bolt', k: 'energy', h: 'energy-driven-strips' },
    { id: 'focus', label: 'Focus', word: 'focus', sub: 'Clear, deep work', icon: 'target', k: 'focus', h: 'focus-clarity-strips' },
    { id: 'calm', label: 'Calm', word: 'calm', sub: 'Take the edge off', icon: 'leaf', k: 'calm', h: 'relax-calm-strips' },
    { id: 'gut', label: 'Gut health', word: 'gut health', sub: 'Digestive comfort', icon: 'drop', k: 'gut', h: 'digestive-gut-health-strips' },
    { id: 'glow', label: 'Hair, skin & nails', word: 'hair, skin and nails', sub: 'Glow from within', icon: 'sparkle', k: 'glow', h: 'beauty-glow-strips' },
    { id: 'longevity', label: 'Healthy aging', word: 'healthy aging', sub: 'Skin, hair and joints', icon: 'heart', k: 'longevity', h: 'longevity-strips' },
    { id: 'appetite', label: 'Appetite & metabolism', word: 'appetite and metabolism', sub: 'With a balanced diet', icon: 'sun', k: 'appetite', h: 'appetite-weight-loss-strips' },
    { id: 'bone', label: 'Bone health', word: 'bone health', sub: 'Calcium absorption', icon: 'shield', k: 'bone', h: 'bone-joints-strips' },
    { id: 'vitality', label: 'Vitality', word: 'vitality', sub: 'Stamina and drive', icon: 'user', k: 'vitality', h: 'testosterone-strips' },
    { id: 'recovery', label: 'The morning after', word: 'the morning after', sub: 'After a night out', icon: 'refresh', k: 'recovery', h: 'hangover-recovery-strips' },
    { id: 'allday', label: 'All-day routine', word: 'an all-day routine', sub: 'Morning to night', icon: 'clock', k: 'focus', h: '' }
  ];
  var G = {}; GOALS.forEach(function (g) { G[g.id] = g; });
  var FOLLOW = {
    sleep: ['What gets in the way <em>at night?</em>', [['mind', 'Switching off my mind', 'switching off at night is the hard part'], ['fall', 'Falling asleep', 'falling asleep is the hard part'], ['stay', 'Waking up in the night', 'you tend to wake up in the night'], ['groggy', 'Feeling groggy in the morning', 'mornings feel groggy']]],
    energy: ['When does your energy <em>dip?</em>', [['am', 'Getting going in the morning', 'mornings are the slowest part of your day'], ['pm', 'The mid-afternoon slump', 'the mid-afternoon slump hits hardest'], ['gym', 'Before workouts', 'you want more in the tank before workouts'], ['all', 'On and off, all day', 'your energy dips on and off all day']]],
    focus: ['Where do you need focus <em>most?</em>', [['desk', 'Deep work at my desk', 'deep work at your desk matters most'], ['study', 'Studying', 'you need focus for studying'], ['meet', 'Long meetings and calls', 'long meetings drain your focus'], ['create', 'Creative work', 'creative work is where focus matters']]],
    calm: ['When do you feel <em>most on edge?</em>', [['work', 'During busy workdays', 'busy workdays are the toughest'], ['eve', 'In the evening', 'evenings are when you most need to unwind'], ['big', 'Before big moments', 'big moments put you on edge'], ['all', 'Most of the day', 'you would like more calm across the day']]],
    gut: ['What would you like <em>support with?</em>', [['meals', 'Comfort after meals', 'comfort after meals matters most'], ['balance', 'Everyday gut balance', 'everyday gut balance is the goal'], ['both', 'Both', 'you want comfort after meals and everyday balance']]],
    glow: ['What matters <em>most to you?</em>', [['hair', 'Hair', 'healthy hair matters most'], ['skin', 'Skin', 'healthy skin matters most'], ['nails', 'Nails', 'healthy nails matter most'], ['all', 'All three', 'hair, skin and nails all matter']]],
    longevity: ['What are you <em>focused on?</em>', [['skin', 'Skin', 'skin is your focus'], ['hair', 'Hair', 'hair is your focus'], ['joints', 'Joints', 'joints are your focus'], ['all', 'All of it', 'you want to look after all of it']]],
    appetite: ['What would help you <em>most?</em>', [['diet', 'Sticking to a balanced diet', 'a balanced diet is the goal'], ['metab', 'Supporting my metabolism', 'metabolism support is the goal'], ['active', 'Staying active', 'you are pairing it with an active lifestyle'], ['consistent', 'Staying consistent', 'consistency is the goal']]],
    bone: ['What is your <em>focus?</em>', [['age', 'Bone health as I age', 'bone health as you age is the focus'], ['active', 'Staying active', 'staying active matters most'], ['d3', 'Getting enough vitamin D', 'getting enough vitamin D is on your mind'], ['all', 'All of it', 'you want to cover all of it']]],
    vitality: ['What do you want <em>more of?</em>', [['stamina', 'Stamina', 'you want more stamina'], ['drive', 'Drive', 'you want more drive'], ['energy', 'Energy', 'you want more energy'], ['all', 'All of it', 'you want all of it']]],
    recovery: ['When do you <em>need it?</em>', [['weekend', 'Weekends out', 'weekends out are the usual occasion'], ['work', 'Work events', 'work events are the usual occasion'], ['travel', 'Travel', 'travel is the usual occasion'], ['celebrate', 'Celebrations', 'celebrations are the usual occasion']]],
    allday: ['Where do you need the <em>most support?</em>', [['am', 'Mornings', 'mornings need the most support'], ['pm', 'Afternoons', 'afternoons need the most support'], ['eve', 'Evenings', 'evenings need the most support'], ['all', 'All of it', 'you want support from morning to night']]]
  };
  var PILLS = [['swallow', 'I hate swallowing pills', 'Nothing to swallow, ever.'], ['forget', 'I always forget to take them', 'One strip, one moment. Easy to keep.'], ['many', 'I already take too many', 'One thin strip instead of another capsule.'], ['fine', 'I’m fine with them', 'Even simpler than a pill.']];
  var PACKS = [['the-vitality-pack', ['energy-driven-strips', 'focus-clarity-strips', 'sleep-rest-strips']], ['the-man-essential', ['testosterone-strips', 'energy-driven-strips', 'focus-clarity-strips']], ['the-women-essentials', ['beauty-glow-strips', 'longevity-strips', 'relax-calm-strips']], ['feel-better-pack', ['digestive-gut-health-strips', 'probiotic-metabolism-strips', 'hangover-recovery-strips']]];
  var PAIR = { 'sleep-rest-strips': 'relax-calm-strips', 'relax-calm-strips': 'sleep-rest-strips', 'energy-driven-strips': 'focus-clarity-strips', 'focus-clarity-strips': 'energy-driven-strips', 'digestive-gut-health-strips': 'probiotic-metabolism-strips', 'probiotic-metabolism-strips': 'digestive-gut-health-strips', 'beauty-glow-strips': 'longevity-strips', 'longevity-strips': 'beauty-glow-strips', 'appetite-weight-loss-strips': 'probiotic-metabolism-strips', 'bone-joints-strips': 'longevity-strips', 'testosterone-strips': 'energy-driven-strips', 'hangover-recovery-strips': 'digestive-gut-health-strips' };
  var PLAN_NAME = { '90': '90-day plan', '60': '60-day plan', '30': '30-day plan', once: 'One-time' };
  var MONTHS = { '90': 3, '60': 2, '30': 1, once: 1 };
  var ORDER = ['intro', 'goals', 'follow', 'pills', 'meet', 'commit', 'email', 'build', 'result'];
  var PROG = { intro: 0, goals: 14, follow: 30, pills: 46, meet: 60, commit: 72, email: 88, build: 96, result: 100 };
  var COUNT = { goals: 1, follow: 2, pills: 3, meet: 3, commit: 4, email: 5 };

  /* ---------- state ---------- */
  var S = { goals: [], follow: '', pills: '', commit: '', plan: '', addon: false, email: '', unlocked: false };
  function load() { try { var o = JSON.parse(localStorage.getItem(STORE) || '{}'); for (var k in o) if (k in S) S[k] = o[k]; } catch (e) {} }
  function save() { try { localStorage.setItem(STORE, JSON.stringify(S)); } catch (e) {} }
  load();
  S.goals = (S.goals || []).filter(function (g) { return G[g]; }).slice(0, 3);

  /* ---------- routine ---------- */
  function tone(h) { return (P[h] && P[h].tone) || 'sage'; }
  function kvar(h) { return 'var(--ritual-' + tone(h) + ', var(--sage))'; }
  function gutPick(primary) {
    if (!primary) return ['digestive-gut-health-strips'];
    if (S.follow === 'balance') return ['probiotic-metabolism-strips'];
    if (S.follow === 'both') return ['digestive-gut-health-strips', 'probiotic-metabolism-strips'];
    return ['digestive-gut-health-strips'];
  }
  function routine() {
    var hs = [], by = {};
    S.goals.forEach(function (g, i) {
      var list = g === 'gut' ? gutPick(i === 0) : g === 'allday' ? ['energy-driven-strips', 'focus-clarity-strips', 'sleep-rest-strips'] : [G[g].h];
      list.forEach(function (h) { if (hs.indexOf(h) < 0) hs.push(h); (by[h] = by[h] || []).push(g); });
    });
    PACKS.forEach(function (pk) {
      if (!P[pk[0]] || !P[pk[0]].av) return;
      if (!pk[1].every(function (h) { return hs.indexOf(h) >= 0; })) return;
      var at = Math.min.apply(null, pk[1].map(function (h) { return hs.indexOf(h); }));
      var gs = [];
      pk[1].forEach(function (h) { (by[h] || []).forEach(function (g) { if (gs.indexOf(g) < 0) gs.push(g); }); });
      hs = hs.filter(function (h) { return pk[1].indexOf(h) < 0; });
      hs.splice(Math.min(at, hs.length), 0, pk[0]);
      by[pk[0]] = gs;
    });
    hs = hs.filter(function (h) { return P[h] && P[h].av; });
    if (!hs.length) { var f = ['sleep-rest-strips', 'energy-driven-strips', 'focus-clarity-strips'].filter(function (h) { return P[h] && P[h].av; })[0]; if (f) { hs = [f]; by[f] = S.goals.slice(0, 1); } }
    return hs.map(function (h) { return { h: h, goals: by[h] || [], lead: (by[h] || []).indexOf(S.goals[0]) >= 0 }; });
  }
  function addonFor(list) {
    if (list.length !== 1 || P[list[0].h].pack) return null;
    var a = PAIR[list[0].h];
    return a && P[a] && P[a].av ? a : null;
  }
  function hour(t) {
    t = t || '';
    var m = t.match(/(\d{1,2})\s*(AM|PM)/i);
    if (m) { var h = +m[1] % 12; if (/pm/i.test(m[2])) h += 12; return h; }
    if (/before meals/i.test(t)) return 11.5;
    if (/after meals/i.test(t)) return 13.5;
    if (/night out/i.test(t)) return 21;
    return 6;
  }
  function items() {
    var r = routine();
    var a = addonFor(r);
    var list = r.map(function (x) { return x.h; });
    if (a && S.addon) list.push(a);
    return list;
  }
  function planKeys() {
    var h = items()[0];
    var ks = ['90', '60', '30'].filter(function (k) { return P[h] && P[h].plans && P[h].plans[k]; });
    ks.push('once');
    return ks;
  }
  function price(plan, list) {
    list = list || items();
    var t = { billed: 0, month: 0, compare: 0, first: 0, units: 0, off: 0 };
    list.forEach(function (h) {
      var p = P[h], pl = plan !== 'once' && p.plans && p.plans[plan];
      var b = pl ? pl.pr : p.p, m = pl ? pl.pd : p.p;
      if (pl) t.off = Math.max(t.off, pl.off || 0);
      t.billed += b; t.month += m; t.compare += p.p * MONTHS[plan];
      t.first += D.code ? Math.round(b * 0.8) : b;
      t.units += (p.pack ? 3 : 1) * MONTHS[plan];
    });
    return t;
  }
  function gifts(plan, t) {
    var g = D.gifts || {}, out = [];
    if (g.pouch && t.units >= 2) out.push({ kind: 'pouch', name: g.pouch.name, p: g.pouch.p, img: g.pouch.img });
    if (g.pouch && g.bottle && t.units >= 3) out.push({ kind: 'bottle', name: g.bottle.name, p: g.bottle.p, img: g.bottle.img });
    var n = plan === '90' ? 3 : plan === '60' ? 2 : 0;
    if (n) out.push({ kind: 'proto', name: n + ' Protocols', p: (g.proto || 0) * n });
    return out;
  }
  function defaultPlan() {
    var ks = planKeys();
    var want = S.commit || '90';
    return ks.indexOf(want) >= 0 ? want : ks[0];
  }

  /* ---------- navigation ---------- */
  var cur = '';
  var bar = $('[data-spq-progress]'), cnt = $('[data-spq-count]'), back = $('[data-spq-back]');
  function go(step, opts) {
    opts = opts || {};
    if (step === 'build' && opts.pop) step = 'commit';
    if ((step === 'follow' || step === 'pills' || step === 'meet' || step === 'commit') && !S.goals.length) step = 'goals';
    if (step === 'result' && !(S.unlocked && S.goals.length)) step = S.goals.length ? 'email' : 'intro';
    if (step === 'email' && S.unlocked) step = opts.pop ? 'commit' : 'build';
    var prev = cur; cur = step;
    $$('[data-spq-step]').forEach(function (el) {
      var on = el.getAttribute('data-spq-step') === step;
      el.hidden = !on;
      el.classList.toggle('is-back', on && ORDER.indexOf(step) < ORDER.indexOf(prev));
    });
    root.setAttribute('data-step', step);
    if (render[step]) render[step]();
    if (bar) bar.style.width = (PROG[step] || 0) + '%';
    if (cnt) cnt.textContent = COUNT[step] ? COUNT[step] + ' / 5' : '';
    if (back) back.hidden = step === 'intro' || step === 'build' || step === 'result';
    if (!opts.pop) { try { history[prev ? 'pushState' : 'replaceState']({ spq: step }, '', '#' + step); } catch (e) {} }
    window.scrollTo(0, 0);
    var h = $('[data-spq-step="' + step + '"] [tabindex="-1"]');
    if (h && prev) { try { h.focus({ preventScroll: true }); } catch (e) {} }
    stickWatch();
  }
  window.addEventListener('popstate', function (e) {
    var st = (e.state && e.state.spq) || (location.hash || '').slice(1) || 'intro';
    if (ORDER.indexOf(st) < 0) st = 'intro';
    go(st, { pop: true });
  });
  if (back) back.addEventListener('click', function () { history.back(); });

  /* ---------- renderers ---------- */
  var render = {};
  render.intro = function () { var r = $('[data-spq-resume]'); if (r) r.hidden = !(S.unlocked && S.goals.length); };

  var goalsBox = $('[data-spq-goals]'), goalN = $('[data-spq-goal-n]'), goalNote = $('[data-spq-goal-note]');
  var goalNext = $('[data-spq-next="follow"]');
  goalsBox.innerHTML = GOALS.map(function (g) {
    return '<button type="button" class="spq-goal" style="--k:var(--ritual-' + g.k + ', var(--sage))" data-goal="' + g.id + '" aria-pressed="false"><span class="spq-goal__ico" aria-hidden="true">' + icon(g.icon) + '</span><b>' + esc(g.label) + '</b><small>' + esc(g.sub) + '</small><span class="spq-goal__n" aria-hidden="true"></span></button>';
  }).join('');
  function syncGoals() {
    $$('.spq-goal', goalsBox).forEach(function (b) {
      var i = S.goals.indexOf(b.getAttribute('data-goal'));
      b.setAttribute('aria-pressed', i >= 0 ? 'true' : 'false');
      b.querySelector('.spq-goal__n').textContent = i >= 0 ? i + 1 : '';
    });
    goalNext.disabled = !S.goals.length;
    goalN.textContent = S.goals.length ? ' · ' + S.goals.length + ' of 3' : '';
  }
  render.goals = function () { syncGoals(); goalNote.textContent = ''; };
  goalsBox.addEventListener('click', function (e) {
    var b = e.target.closest('.spq-goal'); if (!b) return;
    var id = b.getAttribute('data-goal'), i = S.goals.indexOf(id);
    if (i >= 0) { S.goals.splice(i, 1); goalNote.textContent = ''; }
    else if (S.goals.length < 3) { S.goals.push(id); goalNote.textContent = S.goals.length === 1 ? 'Your #1 leads your routine.' : ''; }
    else { b.classList.remove('is-shake'); void b.offsetWidth; b.classList.add('is-shake'); goalNote.textContent = 'You can pick up to 3. Tap one to swap it out.'; return; }
    S.follow = ''; S.addon = false;
    syncGoals(); save();
  });

  function opts(box, list, sel, onPick, extra) {
    box.innerHTML = list.map(function (o) {
      var x = extra ? extra(o) : {};
      return '<button type="button" role="radio" class="spq-opt' + (x.cls ? ' ' + x.cls : '') + '" data-v="' + esc(o[0]) + '" aria-checked="' + (sel === o[0] ? 'true' : 'false') + '"><span class="spq-opt__dot" aria-hidden="true"></span><span class="spq-opt__txt"><b>' + esc(o[1]) + '</b>' + (x.sub ? '<small>' + x.sub + '</small>' : '') + '</span>' + (x.tag ? '<span class="spq-opt__tag' + (x.tagCls ? ' ' + x.tagCls : '') + '">' + esc(x.tag) + '</span>' : '') + '<span class="spq-opt__go" aria-hidden="true">' + icon('arrow') + '</span></button>';
    }).join('');
    box.onclick = function (e) {
      var b = e.target.closest('.spq-opt'); if (!b || box.__busy) return;
      box.__busy = true;
      $$('.spq-opt', box).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      onPick(b.getAttribute('data-v'));
      save();
      setTimeout(function () { box.__busy = false; }, 600);
    };
  }
  function later(step) { setTimeout(function () { go(step); }, 320); }

  render.follow = function () {
    var g = S.goals[0], f = FOLLOW[g] || FOLLOW.allday;
    var tag = $('[data-spq-follow-tag]');
    tag.innerHTML = '<i style="--k:var(--ritual-' + G[g].k + ', var(--sage))"></i>Your #1 · ' + esc(G[g].label);
    $('[data-spq-follow-h]').innerHTML = f[0];
    opts($('[data-spq-follow]'), f[1].map(function (o) { return [o[0], o[1]]; }), S.follow, function (v) { S.follow = v; S.addon = false; later('pills'); });
  };
  render.pills = function () {
    opts($('[data-spq-pills]'), PILLS.map(function (o) { return [o[0], o[1]]; }), S.pills, function (v) { S.pills = v; later('meet'); });
  };
  render.meet = function () {
    var r = routine();
    var lead = r.filter(function (x) { return x.lead; })[0] || r[0];
    var p = P[lead.h];
    var box = $('[data-spq-meet-art]');
    box.innerHTML = art(lead.h);
    box.classList.toggle('is-pack', !!p.pack);
    box.style.setProperty('--k', kvar(lead.h));
    $('[data-spq-meet-eyebrow]').textContent = p.pack ? 'Your match · three strips, one pack' : 'Your match for ' + G[S.goals[0]].label.toLowerCase();
    $('[data-spq-meet-h]').innerHTML = esc(p.t);
    var pl = PILLS.filter(function (o) { return o[0] === S.pills; })[0];
    $('[data-spq-meet-pill]').textContent = (pl ? pl[2] + ' ' : '') + 'It dissolves on your tongue in seconds. No water needed.';
    $('[data-spq-meet-lines]').innerHTML = (p.lines || []).map(function (l) { return '<li>' + icon('check') + '<span>' + esc(l) + '</span></li>'; }).join('');
    $('[data-spq-meet-ings]').textContent = [p.ings, p.flavor].filter(Boolean).join(' · ').replace(/&#39;/g, '’');
    var more = $('[data-spq-meet-more]'), rest = r.filter(function (x) { return x !== lead; });
    more.hidden = !rest.length;
    if (rest.length) more.innerHTML = '<i aria-hidden="true">' + rest.map(function (x) { return '<span style="--k:' + kvar(x.h) + '"></span>'; }).join('') + '</i>+ ' + rest.length + ' more in your routine: ' + rest.map(function (x) { return esc(P[x.h].short || P[x.h].t); }).join(', ');
  };
  render.commit = function () {
    var ks = planKeys(), t90 = price('90'), list = [];
    var g90 = gifts('90', t90), g60 = gifts('60', price('60'));
    function giftWords(gs) { var w = gs.map(function (g) { return g.kind === 'pouch' ? 'Pouch' : g.kind === 'bottle' ? 'Bottle' : g.name; }); return w.length ? ' + ' + (w.length > 1 ? w.slice(0, -1).join(', ') + ' & ' + w[w.length - 1] : w[0]) : ''; }
    var meta = {};
    ks.forEach(function (k) {
      var t = price(k);
      if (k === '90') { list.push(['90', '3 months · build the ritual']); meta['90'] = { sub: t.off + '% off, free shipping' + giftWords(g90), tag: 'Best value', cls: 'spq-opt--best' }; }
      if (k === '60') { list.push(['60', '2 months · get into a rhythm']); meta['60'] = { sub: t.off + '% off, free shipping' + giftWords(g60) }; }
      if (k === '30') { list.push(['30', '1 month · just try it']); meta['30'] = { sub: t.off + '% off · cancel anytime after your first order' }; }
      if (k === 'once') { list.push(['once', 'Just once']); meta.once = { sub: 'Full price, no subscription' }; }
    });
    opts($('[data-spq-commit]'), list, S.commit, function (v) { S.commit = v; S.plan = v; later(S.unlocked ? 'build' : 'email'); }, function (o) { return meta[o[0]] || {}; });
  };
  render.email = function () {
    var r = routine(), pv = $('[data-spq-gate-preview]');
    pv.innerHTML = r.slice(0, 3).map(function (x) { return '<div class="spq-gp__row"><div class="spq-gp__art">' + art(x.h) + '</div><div class="spq-gp__lines"><span></span><span></span><span style="width:60%"></span></div></div>'; }).join('') + '<span class="spq-gp__lock">' + icon('lock') + 'Unlocks with your email</span>';
    var em = $('[data-spq-email]'); if (em && S.email && !em.value) em.value = S.email;
  };
  render.build = function () {
    var r = routine();
    var lines = ['Matched your goals: ' + S.goals.map(function (g) { return G[g].label; }).join(', '), 'Timed to your day: ' + r.length + (r.length > 1 ? ' strips' : ' strip'), D.code ? 'Unlocked 20% off your first order' : 'Pricing your plan'];
    var ul = $('[data-spq-build-list]');
    ul.innerHTML = lines.map(function (l) { return '<li>' + icon('check') + '<span>' + esc(l) + '</span></li>'; }).join('');
    $$('li', ul).forEach(function (li, i) { setTimeout(function () { li.classList.add('is-on'); }, 250 + i * 480); });
    clearTimeout(render.__bt);
    render.__bt = setTimeout(function () { if (cur === 'build') go('result'); }, 2000);
  };

  render.result = function () {
    if (!S.plan || planKeys().indexOf(S.plan) < 0) S.plan = defaultPlan();
    var r = routine();
    var words = S.goals.map(function (g) { return '<em>' + esc(G[g].word) + '</em>'; });
    $('[data-spq-res-h]').innerHTML = 'Built for ' + (words.length > 1 ? words.slice(0, -1).join(', ') + ' and ' + words[words.length - 1] : words[0]) + '.';
    var f = (FOLLOW[S.goals[0]] || FOLLOW.allday)[1].filter(function (o) { return o[0] === S.follow; })[0];
    $('[data-spq-res-lead]').textContent = 'You told us your #1 is ' + G[S.goals[0]].label.toLowerCase() + (f ? ', and that ' + f[2] : '') + '. Here’s the routine we’d start with, timed to your day.';
    var sorted = r.slice().sort(function (a, b) { return hour(P[a.h].time) - hour(P[b.h].time); });
    $('[data-spq-routine]').innerHTML = sorted.map(function (x, i) {
      var p = P[x.h];
      var forTxt = x.goals.length ? (x.goals.indexOf(S.goals[0]) >= 0 ? 'Your #1: ' : 'For ') + x.goals.map(function (g) { return G[g].label; }).join(' + ') : '';
      return '<li class="spq-r" style="--k:' + kvar(x.h) + '"><span class="spq-r__rail" aria-hidden="true"><i></i></span><div class="spq-r__card" style="--d:' + i + '"><div class="spq-r__art' + (p.pack ? ' is-pack' : '') + '">' + art(x.h) + '</div><div><p class="spq-r__time">' + esc(p.time) + (p.flavor ? ' · ' + esc(p.flavor) : '') + '</p><h3 class="spq-r__name">' + esc(p.t) + '</h3>' + (forTxt ? '<p class="spq-r__for">' + esc(forTxt) + '</p>' : '') + '<p class="spq-r__ben">' + esc(p.benefit) + '</p><p class="spq-r__ings">' + p.ings + '</p><a class="spq-r__link" href="' + esc(p.url) + '">Details' + icon('arrow') + '</a></div></div></li>';
    }).join('');
    renderAddon(r);
    renderSum();
  };
  function renderAddon(r) {
    var a = addonFor(r), box = $('[data-spq-addon]');
    if (!a) { box.hidden = true; box.innerHTML = ''; return; }
    var p = P[a];
    var base = price(S.plan, [r[0].h]), withA = price(S.plan, [r[0].h, a]);
    var unlock = D.gifts && D.gifts.pouch && base.units < 2 && withA.units >= 2 ? ' Adds a free Suprimal Pouch to your first order.' : '';
    box.hidden = false;
    box.classList.toggle('is-on', !!S.addon);
    box.style.setProperty('--k', kvar(a));
    box.innerHTML = '<div class="spq-addon__art">' + art(a) + '</div><div><p class="spq-addon__k">Pairs well · ' + esc(p.time) + '</p><p class="spq-addon__name">' + esc(p.t) + '</p><p class="spq-addon__why">' + esc(p.benefit) + esc(unlock) + '</p></div><button type="button" class="spq-addon__btn" aria-pressed="' + (S.addon ? 'true' : 'false') + '">' + (S.addon ? icon('check') + 'Added' : icon('plus') + 'Add · ' + fmt(price(S.plan, [a]).month) + (S.plan === 'once' ? '' : '/mo')) + '</button>';
    box.querySelector('.spq-addon__btn').onclick = function () { S.addon = !S.addon; save(); renderAddon(r); renderSum(); };
  }
  function renderSum() {
    var ks = planKeys();
    if (ks.indexOf(S.plan) < 0) S.plan = defaultPlan();
    var plans = $('[data-spq-plans]');
    plans.innerHTML = ks.map(function (k) {
      var t = price(k), on = k === S.plan;
      var priceHtml = k === 'once' ? fmt(t.billed) : fmt(t.month) + '<small>/mo</small>';
      var sub = k === 'once' ? 'One-time purchase · no renewal' : 'Billed ' + fmt(t.billed) + (k === '30' ? ' monthly' : ' every ' + MONTHS[k] + ' months') + ' · <s>' + fmt(t.compare) + '</s> save ' + t.off + '%';
      return '<button type="button" role="radio" class="spq-plan" data-plan="' + k + '" aria-checked="' + on + '">' + (k === '90' ? '<span class="spq-plan__best">Best value</span>' : '') + '<span class="spq-opt__dot" aria-hidden="true"></span><span class="spq-plan__name">' + PLAN_NAME[k] + (k !== 'once' && t.off ? '<em>' + t.off + '% off</em>' : '') + '</span><span class="spq-plan__price">' + priceHtml + '</span><span class="spq-plan__sub">' + sub + '</span></button>';
    }).join('');
    plans.onclick = function (e) { var b = e.target.closest('.spq-plan'); if (!b) return; S.plan = b.getAttribute('data-plan'); save(); renderAddon(routine()); renderSum(); };
    var t = price(S.plan), gs = gifts(S.plan, t), gb = $('[data-spq-gifts]');
    if (gs.length) {
      var tot = gs.reduce(function (a, g) { return a + (g.p || 0); }, 0);
      gb.hidden = false;
      gb.innerHTML = '<p>' + (tot ? fmt(tot) + ' in gifts with your first order' : 'Free gifts with your first order') + '</p><ul>' + gs.map(function (g) {
        var im = g.kind === 'proto' ? '<span class="spq-covers" aria-hidden="true"><span style="background:#1f2442;color:#f3eee4"><small>Nº 02</small><b>Deep Sleep</b></span><span style="background:#f0e4cc;color:#1b201a"><small>Nº 04</small><b>Energy</b></span><span style="background:#e5e9d6;color:#1b201a"><small>Nº 05</small><b>Gut Health</b></span></span>' : (g.img ? '<img src="' + esc(g.img) + '" alt="" loading="lazy" width="120" height="120">' : '');
        return '<li class="spq-gift"><span class="spq-gift__img">' + im + '</span><b>' + esc(g.name) + '</b>' + (g.p ? '<s>' + fmt(g.p) + '</s>' : '') + '</li>';
      }).join('') + '</ul>';
    } else { gb.hidden = true; gb.innerHTML = ''; }
    var rows = [];
    if (S.plan !== 'once') rows.push(['Billed ' + (S.plan === '30' ? 'monthly' : 'every ' + MONTHS[S.plan] + ' months'), fmt(t.billed)]);
    if (D.code) rows.push(['20% off first order (' + esc(D.code) + ')', '−' + fmt(t.billed - t.first), 'is-code']);
    rows.push([D.code ? 'Your first order' : (S.plan === 'once' ? 'Total' : 'Per delivery cycle'), fmt(t.first), 'is-total']);
    $('[data-spq-tot]').innerHTML = rows.map(function (r) { return '<div class="' + (r[2] || '') + '"><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>'; }).join('');
    var n = items().length;
    $('[data-spq-add-label]').textContent = 'Add my routine · ' + fmt(t.first);
    $('[data-spq-guarantee]').textContent = S.plan === 'once' ? 'Covered by our 90-day return policy' : MONTHS[S.plan] * 30 + '-day money-back guarantee';
    $('[data-spq-cancel]').textContent = S.plan === 'once' ? 'No subscription, no renewal' : 'Cancel anytime after your first order';
    $('[data-spq-stick-price]').textContent = fmt(t.first);
    $('[data-spq-stick-note]').textContent = n + (n > 1 ? ' strips' : ' strip') + ' · ' + PLAN_NAME[S.plan] + (D.code ? ' · 20% off' : '');
  }

  /* ---------- sticky bar (phone) ---------- */
  var stick = $('[data-spq-stick]'), sumBtn = $('.spq-sum__btn'), io;
  function stickWatch() {
    if (!stick) return;
    stick.hidden = cur !== 'result';
    if (cur !== 'result' || !('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(function (es) { es.forEach(function (x) { stick.classList.toggle('is-on', !x.isIntersecting && cur === 'result'); }); });
    io.observe(sumBtn);
  }

  /* ---------- Klaviyo + store ---------- */
  function props() {
    var r = routine(), f = (FOLLOW[S.goals[0]] || FOLLOW.allday)[1].filter(function (o) { return o[0] === S.follow; })[0];
    var pl = PILLS.filter(function (o) { return o[0] === S.pills; })[0];
    var o = {
      'Signup form': 'Quiz',
      'Quiz goals': S.goals.map(function (g) { return G[g].label; }).join(', '),
      'Quiz primary goal': G[S.goals[0]] ? G[S.goals[0]].label : '',
      'Quiz detail': f ? f[1] : '',
      'Quiz pills': pl ? pl[1] : '',
      'Quiz pace': PLAN_NAME[S.commit] || '',
      'Quiz recommendation': r.map(function (x) { return P[x.h].t; }).join(', '),
      'Quiz recommendation handles': r.map(function (x) { return x.h; }).join(','),
      'Quiz completed at': new Date().toISOString()
    };
    if (D.code) o['Welcome code'] = D.code;
    return o;
  }
  function kpost(path, body) {
    if (!D.key) return Promise.resolve(false);
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(D.key), { method: 'POST', headers: { 'Content-Type': 'application/json', revision: REVISION }, body: JSON.stringify(body) }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function subscribe(email, phone) {
    var pr = props(), attrs = { email: email, properties: pr }, subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (phone) { attrs.phone_number = phone; pr['SMS consent collected at'] = new Date().toISOString(); pr['SMS consent source'] = 'Quiz'; subs.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
    var body = { data: { type: 'subscription', attributes: { custom_source: 'Quiz', profile: { data: { type: 'profile', attributes: attrs } }, subscriptions: subs }, relationships: { list: { data: { type: 'list', id: D.list } } } } };
    return kpost('subscriptions', body).then(function (ok) {
      if (ok || !phone) return ok;
      var p2 = props(); p2['Phone (SMS consent pending)'] = phone; p2['SMS consent collected at'] = new Date().toISOString(); p2['SMS consent source'] = 'Quiz';
      return kpost('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Quiz', profile: { data: { type: 'profile', attributes: { email: email, properties: p2 } } }, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }, relationships: { list: { data: { type: 'list', id: D.list } } } } });
    });
  }
  function track(email) {
    var pr = props(), r = routine();
    pr['Recommended products'] = r.map(function (x) { return P[x.h].t; });
    return kpost('events', { data: { type: 'event', attributes: { properties: pr, metric: { data: { type: 'metric', attributes: { name: 'Completed Quiz' } } }, profile: { data: { type: 'profile', attributes: { email: email } } } } } });
  }
  function shopifyCustomer(email) {
    try {
      var fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '✓'); fd.append('contact[email]', email); fd.append('contact[tags]', 'newsletter,quiz');
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    } catch (e) {}
  }
  function popupDone() {
    try { var k = 'spw_state_v1', s = JSON.parse(localStorage.getItem(k) || '{}'); s.subscribed = s.subscribed || Date.now(); s.revealed = s.revealed || Date.now(); s.teaserHidden = Date.now(); localStorage.setItem(k, JSON.stringify(s)); } catch (e) {}
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: S.email }); } catch (e) {}
  }

  var form = $('[data-spq-form]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var em = $('[data-spq-email]'), ph = $('[data-spq-phone]'), ee = $('[data-spq-email-error]'), pe = $('[data-spq-phone-error]');
    var v = (em.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { ee.textContent = 'Enter a valid email address, like you@example.com.'; ee.hidden = false; em.setAttribute('aria-invalid', 'true'); em.focus(); return; }
    ee.hidden = true; em.removeAttribute('aria-invalid');
    var d = (ph.value || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d && d.length !== 10) { pe.textContent = 'Enter a 10-digit US number, or leave it blank.'; pe.hidden = false; ph.setAttribute('aria-invalid', 'true'); ph.focus(); return; }
    pe.hidden = true; ph.removeAttribute('aria-invalid');
    S.email = v; S.unlocked = true; S.plan = S.commit || ''; save();
    var phone = d ? '+1' + d : '';
    subscribe(v, phone).then(function () { track(v); });
    shopifyCustomer(v);
    popupDone();
    go('build');
  });

  /* ---------- add to bag ---------- */
  function post(url, body) {
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to your bag.'); return j; }); });
  }
  function addAll(btn) {
    var err = $('[data-spq-add-error]');
    err.hidden = true;
    var all = $$('[data-spq-add]');
    all.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
    var list = items().map(function (h) {
      var p = P[h], pl = S.plan !== 'once' && p.plans && p.plans[S.plan];
      var o = { id: p.v, quantity: 1 };
      if (pl) o.selling_plan = pl.id;
      return o;
    });
    post('cart/add.js', { items: list })
      .then(function () {
        if (!D.code) return;
        return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          var codes = (c.discount_codes || []).map(function (x) { return x.code; });
          if (codes.map(function (x) { return x.toUpperCase(); }).indexOf(D.code) >= 0) return;
          return post('cart/update.js', { discount: codes.concat(D.code).join(',') });
        }).catch(function () {});
      })
      .then(function () {
        if (window.SuprimalCart && window.SuprimalCart.refresh) return window.SuprimalCart.refresh(true);
        location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
      })
      .catch(function (e) { err.textContent = e.message || 'Something went wrong. Please try again.'; err.hidden = false; })
      .then(function () { all.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; }); });
  }
  $$('[data-spq-add]').forEach(function (b) { b.addEventListener('click', function () { addAll(b); }); });

  /* ---------- misc buttons ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var nx = t.closest('[data-spq-next]'); if (nx && !nx.disabled) { go(nx.getAttribute('data-spq-next')); return; }
    if (t.closest('[data-spq-start]')) { go('goals'); return; }
    if (t.closest('[data-spq-show-result]')) { go('result'); return; }
    if (t.closest('[data-spq-restart]')) { S.goals = []; S.follow = ''; S.pills = ''; S.commit = ''; S.plan = ''; S.addon = false; save(); go('goals'); return; }
    var cp = t.closest('[data-spq-copy]');
    if (cp) {
      var code = cp.getAttribute('data-spq-copy'), lab = cp.querySelector('[data-spq-copy-label]');
      var done = function () { if (lab) { lab.textContent = 'Copied'; setTimeout(function () { lab.textContent = 'Copy'; }, 1800); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
    }
  });

  /* ---------- start ---------- */
  var qs = (location.search.match(/[?&]goal=([a-z]+)/) || [])[1];
  var start = (location.hash || '').slice(1);
  if (qs && G[qs]) { if (S.goals.indexOf(qs) < 0) { S.goals = [qs].concat(S.goals.filter(function (g) { return g !== qs; })).slice(0, 3); S.follow = ''; save(); } go('goals'); }
  else if (start === 'result' && S.unlocked && S.goals.length) go('result');
  else go('intro');
})();
